import React from "react";


import {
    SectionContainerComponent
} from "@Components/Sections";


import {
    LegalElementsListElementComponent,
    LegalElementsListElementType
} from "@Pages/@LegalPages/@Parts/LegalsElementsList/LegalElement";


import "./index.scss";


type LegalElementsListComponentProps = {
    legalPageType: string;
    legalElementsList: LegalElementsListElementType[];
}


export const LegalElementsListComponent:React.FC<LegalElementsListComponentProps> = ({
    legalPageType, legalElementsList
}) => {

    const LegalElementsList = legalElementsList.map((Element, i) =>
        <LegalElementsListElementComponent key={i} Element={Element} />
    );

    return (
        <SectionContainerComponent
            id={`${legalPageType}-page__legals-elements-section legal-page__legals-elements-section`}
            sectionType={'main'}
        >
            {LegalElementsList}
        </SectionContainerComponent>
    );

};


export default LegalElementsListComponent;
